import type { ReactNode } from 'react';
import React from 'react';

import { CliveAvatar } from '~/components/Clive/CliveAvatar';
import { CLIVE_VIBERANT_BORDER } from '~/components/Clive/cliveRegistry';
import Text from '~/components/core/TextComponents/Text';
import cn from '~/Utils/cn';

interface CliveActionBannerProps {
  title: string;
  contentText: string;
  actionComponent?: ReactNode;
}

const IMAGE_SIZE = 44;

const CliveActionBanner: React.FC<CliveActionBannerProps> = ({ title, contentText, actionComponent }) => {
  return (
    <div className={cn('mb-16 flex w-full items-center gap-12 rounded-2xl p-12', CLIVE_VIBERANT_BORDER)}>
      <CliveAvatar mood={CliveAvatar.MOOD.HAPPY} size={IMAGE_SIZE} className="flex-shrink-0" />
      <div className="flex flex-1 flex-col gap-4">
        <Text variant={Text.VARIANTS.XS} weight={Text.WEIGHTS.SEMI_BOLD}>
          {title}
        </Text>
        <Text variant={Text.VARIANTS.XS} weight={Text.WEIGHTS.REGULAR}>
          {contentText}
        </Text>
      </div>
      {actionComponent}
    </div>
  );
};

export default CliveActionBanner;
